export default __webpack_public_path__ + "static/media/cg.1d268b0d.svg";